import * as React from 'react';
import clsx from 'clsx';
import statCardElement from '@/assets/images/svg/stat_card_element.svg';

interface StatCardProps {
  title: string;
  value: string;
  iconSrc: string;
}

/** Stat tile used on the My Echo dashboard (e.g. stars, revenue). */
export const StatCard: React.FC<StatCardProps> = ({ title, value, iconSrc }) => (
  <div
    className={clsx(
      'relative flex size-full flex-col justify-between overflow-hidden',
      'rounded-20 border border-accent-glow bg-brand-800',
      'p-4 lg:p-6'
    )}
  >
    <div className='flex items-start justify-between'>
      <span className='font-sans text-36 font-bold leading-105 tracking-normal text-white lg:text-48'>
        {value}
      </span>
      <img src={iconSrc} alt='' className='size-[30px] object-contain lg:size-[40px]' />
    </div>

    <div className='relative z-10'>
      <span className='font-sans text-12 font-normal leading-14 tracking-normal text-white lg:text-16 lg:leading-27'>
        {title}
      </span>
    </div>

    <img
      src={statCardElement}
      alt=''
      className='pointer-events-none absolute bottom-0 right-0 z-0 opacity-100'
    />
  </div>
);
